import type { FallbackProps, StaticProps } from '@gik/core/api/BaseAPIConfig';
import { ISRRevalidateTimeout, baseFallback } from '@gik/core/api/BaseAPIConfig';
import { withTitle } from '@gik/core/hocs/withTitle';
import type WordpressLegal from '@gik/core/models/wordpress/WordpressLegal';
import { TermsOfService } from '@gik/core/pages/Legal/TermsOfService';
import { catchSSRError } from '@gik/core/utils/catchSSRError';
import { measureSSRPerformance } from '@gik/core/utils/measureSSRPerformance';
import { getTerms } from '@/api/legal';
import type { PageLayoutProps } from '@/components/layout/PageLayout';
import { PageLayout } from '@/components/layout/PageLayout';
import { SWRConfig } from 'swr';

export default function TermsOfServicePageComp({ fallback }: FallbackProps<unknown>) {
  return withTitle(
    'Terms of Service',
    <SWRConfig value={{ fallback }}>
      <TermsOfService />
    </SWRConfig>
  );
}

TermsOfServicePageComp.getLayout = function getLayout(page, layoutProps: PageLayoutProps) {
  return (
    <PageLayout {...layoutProps} key={layoutProps.key}>
      {page}
    </PageLayout>
  );
};

async function _getStaticProps(): Promise<StaticProps<WordpressLegal[]>> {
  const articles = getTerms();

  return baseFallback(
    {
      [articles.key]: await articles.json,
    },
    undefined,
    ISRRevalidateTimeout.sitemapSlow
  );
}

export const getStaticProps = catchSSRError(measureSSRPerformance(_getStaticProps));
